import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { S3Config } from 'dashboard/models/external-integration';
import { setS3Config } from 'dashboard/redux/actions/s3';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint } from 'lib/interfaces/api';

export const loadS3Config = (): DashboardThunkAction => async (dispatch) => {
  const s3Config = await SessionClientDashboard.getEndpoint<S3Config>(
    ApiEndpoint.DataSourceS3Config,
  );

  dispatch(setS3Config(s3Config));
};
